import * as v from 'valibot';

export const FileUploadResult = v.object({
	id: v.string(),
	name: v.string(),
	extension: v.string(),
});

export type FileUploadResult = v.InferOutput<typeof FileUploadResult>;

export const DocumentTypes = v.array(
	v.pipe(
		v.object({
			region: v.string(),
			types: v.array(
				v.object({
					type: v.string(),
					documentTypes: v.array(
						v.object({
							id: v.string(),
							name: v.string(),
						}),
					),
				}),
			),
		}),
		v.transform((obj) => ({
			region: obj.region,
			types: obj.types,
			documentYearIsStart: obj.region === 'USA',
		})),
	),
);

export type DocumentTypes = v.InferOutput<typeof DocumentTypes>;
export type DocumentTypesResponse = v.InferInput<typeof DocumentTypes>;

// SALES DOCUMENTS
export const SalesDocumentPostResponseSchema = v.object({
	salesDocuments: v.array(
		v.object({
			id: v.string(),
			name: v.string(),
			extension: v.string(),
			size: v.number(),
			claimId: v.number(),
			mimeType: v.string(),
			fileStatusId: v.number(),
			uploadedBy: v.string(),
			uploadDate: v.string(),
		}),
	),
	errors: v.array(v.string()),
});

export type SalesDocumentPostResponse = v.InferOutput<
	typeof SalesDocumentPostResponseSchema
>;

export const SalesFileSchema = v.object({
	id: v.string(),
	name: v.string(),
	uploadDate: v.string(),
	size: v.number(),
});

export const SalesFilesForClaimSchema = v.object({
	salesDocuments: v.array(SalesFileSchema),
});

export type SalesFilesForClaim = v.InferOutput<typeof SalesFilesForClaimSchema>;
